import { CenteredLayout, centeredLayoutClasses, } from "@vividtheory/minerva-lab";
import React from "react";
import { Divider, FlexScrollArea, FlexScrollAreaContainer, Grid, Hidden, Typography, } from "../components";
export const CenteredNestedLayoutWithHeader = ({ title, children, disableChildPadding, childrenLayoutSx, bottomNode, }) => {
    return (React.createElement(FlexScrollAreaContainer, { width: "100%" },
        title && (React.createElement(CenteredLayout, { sx: {
                height: "auto",
                paddingX: 4,
                [`& .${centeredLayoutClasses.main}`]: {
                    marginY: "unset",
                },
            } },
            React.createElement(Grid, { container: true, sx: {
                    paddingY: 4,
                } }, typeof title === "string" ? (React.createElement(Typography, { variant: "h6", fontWeight: "bold" }, title)) : (title)))),
        React.createElement(Hidden, { variant: "up", breakpoint: "sm" },
            React.createElement(Divider, null)),
        React.createElement(FlexScrollArea, null,
            React.createElement(CenteredLayout, { sx: Object.assign({ padding: disableChildPadding ? 0 : 4, [`& .${centeredLayoutClasses.main}`]: {
                        marginY: "unset",
                    } }, childrenLayoutSx) }, children)),
        bottomNode));
};
//# sourceMappingURL=CenteredNestedLayoutWithHeader.js.map